import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import bgImage from '../images/background.png';

function GaIcon({ name, size = 22 }) {
    const p = { width: size, height: size, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.5, strokeLinecap: 'round', strokeLinejoin: 'round' };
    switch (name) {
        case 'lock': return <svg {...p}><rect width="18" height="11" x="3" y="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>;
        case 'home': return <svg {...p}><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>;
        default: return null;
    }
}

export default function SubscriptionAlert() {
    const { t } = useTranslation();
    const [ready, setReady] = useState(false);
    const navigate = useNavigate();

    useEffect(() => { requestAnimationFrame(() => setReady(true)); }, []);

    return (
        <div className={`ga-stage${ready ? ' ga-ready' : ''}`}>
            <div className="ga-bg" style={{ backgroundImage: `url(${bgImage})` }} />
            <div className="ga-vignette" />
            <div className="ga-grain" />

            <div className="ga-card">
                <div className="ga-icon"><GaIcon name="lock" size={22} /></div>
                <p className="ga-eyebrow">{t('game_alert.eyebrow')}</p>
                <h1 className="ga-title">{t('subscription_alert.title') || t('choose_wine.title')}</h1>
                <p className="ga-message">{t('subscription_alert.message')}</p>
                <button className="ga-btn" onClick={() => navigate('/')}>
                    <GaIcon name="home" size={16} />
                    {t('common.back_home') || t('common.back')}
                </button>
            </div>
        </div>
    );
}
